// src/components/onboarding/Step3Demo.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';

function Step3Demo() {
  return (
    <>
      <Typography variant="h6" component="p" gutterBottom align="center">
        Step 3: Platform Walkthrough
      </Typography>

      <Box
        sx={{
          width: '100%',
          maxWidth: 800,     // cap width so it doesn't grow infinitely on large screens
          height: 500,       // fixed height for a bigger view
          mx: 'auto',        // center horizontally
          mt: 2,
          mb: 2,
          position: 'relative',
        }}
      >
        <iframe
          title="Arcade Demo"
          src="https://demo.arcade.software/fd5WynPHqtQM6S8wKMXo?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
          }}
          allow="autoplay; fullscreen"
        />
      </Box>
    </>
  );
}

export default Step3Demo;
